import React from "react";

import * as styles from "./content-container.module.css";

const ContentContainer = ({ children }) => {
  return <div className={styles.root}><div>{children}</div></div>;
};

export default ContentContainer;
